import React, { useState, useEffect } from 'react';
import billingService from '../../api/billingService';
import { formatCurrency } from '../../utils/formatters';
import { formatDate } from '../../utils/dateUtils';

const InvoiceList = () => {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoices = async () => {
      try {
        const res = await billingService.getInvoices();
        if (res.success) setInvoices(res.data);
      } catch (error) {
        console.error('Error fetching invoices:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchInvoices();
  }, []);

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'paid': return 'badge-soft-success';
      case 'partially_paid': return 'badge-soft-warning';
      case 'overdue': return 'badge-soft-danger';
      case 'finalized': return 'badge-soft-info';
      default: return 'badge-soft-secondary';
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-700 mb-1">Invoices</h4>
          <p className="text-muted small mb-0">View and track all customer billing statements.</p>
        </div>
        <div className="d-flex gap-2">
          <button 
            className="btn btn-outline-primary"
            onClick={async () => {
              await billingService.triggerRenewals();
              window.location.reload();
            }}
          >
            Run Renewal Engine
          </button>
          <button className="btn btn-primary shadow-sm px-4">
            <i className="bi bi-plus-lg me-2"></i> Create Invoice
          </button>
        </div>
      </div>

      <div className="card border-0 shadow-sm">
        <div className="card-header border-0 bg-transparent pt-4 px-4">
          <div className="d-flex justify-content-between align-items-center">
            <div className="input-group w-25">
              <span className="input-group-text bg-light border-0"><i className="bi bi-search"></i></span>
              <input type="text" className="form-control bg-light border-0" placeholder="Search invoices..." />
            </div>
          </div>
        </div>
        <div className="table-responsive mt-3">
          <table className="table table-hover align-middle">
            <thead>
              <tr>
                <th>Invoice #</th>
                <th>Customer</th>
                <th>Status</th>
                <th>Issue Date</th>
                <th>Due Date</th>
                <th>Total</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="7" className="text-center py-5">Loading...</td></tr>
              ) : invoices.length === 0 ? (
                <tr><td colSpan="7" className="text-center py-5">No invoices found.</td></tr>
              ) : (
                invoices.map((inv) => (
                  <tr key={inv._id}>
                    <td><span className="fw-600">{inv.invoice_number}</span></td>
                    <td><span className="fw-600">{inv.customer?.company_name || 'N/A'}</span></td>
                    <td>
                      <span className={`badge ${getStatusBadgeClass(inv.status)}`}>
                        {inv.status.toUpperCase().replace('_', ' ')}
                      </span>
                    </td>
                    <td>{formatDate(inv.invoice_date)}</td>
                    <td>{formatDate(inv.due_date)}</td>
                    <td><span className="fw-600">{formatCurrency(inv.grand_total)}</span></td>
                    <td className="text-end">
                      <div className="d-flex justify-content-end gap-2">
                        <button className="btn btn-sm btn-light text-primary"><i className="bi bi-eye"></i></button>
                        <button className="btn btn-sm btn-light text-success"><i className="bi bi-credit-card"></i></button>
                        <button className="btn btn-sm btn-light"><i className="bi bi-download"></i></button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InvoiceList;
